// extracted by mini-css-extract-plugin
export var container = "banner-module--container--NkbTN";
export var img = "banner-module--img--0o-HM";
export var textBlock = "banner-module--textBlock--ecEUv";
export var title = "banner-module--title--w9U5J";
export var subTitle = "banner-module--subTitle--JDjjj";
export var btn = "banner-module--btn---OSO6";